<template>
  <div>
    <div class="card card-custom" v-for="c in subject">
      <div class="card-header">
        <h6 class="card-title">{{c.Title}}</h6>
      </div>
      <div class="card-body">
        <div class="row">
          <div class="col-md-4" v-for="item in c.Child">
            <div class="callout callout-navy">
              <table width="100%">
                <tr>
                  <td>
                    {{item.CourseTitle}}
                  </td>
                  <td style="width: 10px;">
                    <button v-if="!item.Evaluated" class="btn btn-info btn-xs" v-on:click="loadQuestions(item.CourseID, c.FeedbackCategoryID, c.FeedbackSurveyCampaignID)">Evaluate</button>
                    <button v-else class="btn btn-success btn-xs" disabled>Evaluated</button>
                  </td>
                </tr>
              </table>
            </div>
          </div>

          <div class="col-md-12">
            <label class="text-danger">Click on the Evaluate button to submit feedback/ survery.</label>
          </div>
        </div>
      </div>
    </div>


    <form v-on:submit="saveEvaluatedQuestions">
      <div class="modal fade" id="mdlQuestions" role="dialog">
        <div class="modal-dialog  modal-lg">
          <!-- Modal content-->
          <div class="modal-content">
            <div class="modal-header bg-custom">
              <h3 style="color: white" class="modal-title">Survey Form</h3>
            </div>
            <div class="modal-body">
              <!--<p style="text-align: center">
                  <span style="font-weight:bold" v-for="item in grade">{{item.Score}}: {{item.Option}}</span>
              </p>
              <hr />-->
              <table width="100%" class="table table-borderless table-sm" v-for="i in questions">
                <tbody>
                  <tr>
                    <th>
                      <h4 style="border-bottom: 1px solid black">{{i.Name}}</h4>
                    </th>
                  </tr>
                  <tr v-for="(item,index) in i.Child">
                    <td>
                      <span>
                        {{index+1}}. {{item.Question}}
                      </span>
                      <table class="table table-borderless table-sm" width="100%" style="margin-bottom: 0px" v-if="item.EvaluatedBy == 'Grade'">
                        <tr>
                          <td v-for="i in grade">
                            <div class="custom-control custom-radio">
                              <input required class="custom-control-input" type="radio" :id="item.QuestionID + '_' +  i.Score" :name="item.QuestionID" :value="i.Option" v-model="item.Option">
                              <label :for="item.QuestionID + '_' + i.Score" class="custom-control-label">{{i.Option}}</label>
                            </div>
                          </td>
                        </tr>
                      </table>
                      <textarea class="form-control" v-else v-model="item.Option"></textarea>
                    </td>
                  </tr>
                  <!--<tr>
                      <td>
                          <span>Comments</span>
                          <textarea v-model="i.Comments" class="form-control"></textarea>
                      </td>
                  </tr>
                  <tr>
                      <td>
                          <hr />
                      </td>
                  </tr>-->
                </tbody>
              </table>
            </div>
            <div class="modal-footer">
              <button type="submit" class="btn btn-success">Save</button>
              <button type="button" class="btn btn-danger" data-dismiss="modal">Cancel</button>
            </div>
          </div>
        </div>
      </div>
    </form>
  </div>
</template>
<script>
  import axios from 'axios';
  export default {
    data() {
      return {
        category: [],
        campaign: [],
        subject: [],
        questions: [],
        grade: [],
        campaignID: 0,
        FeedbackCategoryID: 0,
        categoryID: 0,
        courseID: 0,
      }
    },
    created() {
      this.viewCourses();
    },
    updated() {
      //$('#bs4-table').DataTable();
    },

    methods: {
      viewCourses() {
        startReq();
        var vm = this;
        axios.post('/api/PortalApi/loadCoursesForFeedbackForm')
          .then(function (response) {
            endReq();
            vm.subject = response.data.lst;
            vm.campaignID = response.data.campID;
            vm.FeedbackCategoryID = response.data.FeedbackCategoryID;
            endReq();
          })
      },

      loadQuestions(id, categoryID, campaignID) {
        startReq();
        var vm = this;
        vm.courseID = id;
        vm.campaignID = campaignID
        axios.post('/api/PortalApi/loadFeedbackQuestions?FeedbackCategoryID=' + categoryID)
          .then(function (response) {
            endReq();
            vm.questions = response.data.lst;
            vm.grade = response.data.grade;
            $('#mdlQuestions').modal({ backdrop: 'static', keyboard: false }, 'show');
            endReq();
          })
      },

      saveEvaluatedQuestions() {
        startReq();
        var vm = this;
        axios.post('/api/PortalApi/saveEvaluatedQuestions', {
          lst: vm.questions,
          campID: vm.campaignID,
          subID: vm.courseID,
        })
          .then(function (response) {
            endReq();
            if (response.data.status) {
              toastr.success(response.data.msg);
              $('#mdlQuestions').modal('hide');
              vm.questions = [];
              endReq();

              vm.viewCourses();
            }
            else {
              toastr.error("Somthing Went Wrong");
            }
          })
      },


      redirectLMS(id) {
        startReq();
        window.location.href = "../Portal/UploadAssingment?id=" + id;
      },
    }
  }</script>

<style scoped>
  .callout {
    padding: .6rem;
  }
</style>



// WEBPACK FOOTER //
// src/components/school/LMS/feedBackSurveyForm.vue